import _get from "lodash.get";

import getTokenStatus from "./helpers/getTokenStatus";
import { authFactory as authInstance } from "../factory";
import saveTimeToken from "../provider/timeToken";
import { getStorageData, setStorageData } from "@/utils/storage";

const STORAGE_TIME_TO_EXPIRE_KEY = "timeToExpire";
const STORAGE_USER_KEY = "user";

const refreshToken = async config => {
  if (config.isRefresh) {
    return config;
  }

  const storagedTimeToken = getStorageData(STORAGE_TIME_TO_EXPIRE_KEY);
  if (!storagedTimeToken) {
    return config;
  }

  const storagedUser = getStorageData(STORAGE_USER_KEY);

  config.headers.Authorization = `Bearer ${storagedUser.jwt}`;

  const tokenIsNOTExpired = !getTokenStatus(storagedTimeToken.expireTime);

  if (tokenIsNOTExpired) {
    return config;
  }

  // TODO: refactor it to use a fn
  config.firstURL = config.baseURL;
  config.baseURL = authInstance.defaults.baseURL;
  config.isRefresh = true;

  const refreshTokenResponse = await authInstance.post(
    "/api/auth/refresh",
    null,
    config
  );

  // TODO: verify what happens if this request return an error
  // FIXME: dont use the "expires_in", use the jwt `exp` instead
  const { access_token: jwt, expires_in: newExpiration } = _get(
    refreshTokenResponse,
    "data",
    {}
  );

  saveTimeToken(newExpiration);

  const updatedUser = {
    ...storagedUser,
    jwt
  };

  setStorageData(STORAGE_USER_KEY, updatedUser);

  config.baseURL = config.firstURL;
  delete config.firstURL;
  config.isRefresh = false;
  config.headers.Authorization = `Bearer ${jwt}`;

  return config;
};

export default refreshToken;
